import { CommonModule } from "@angular/common";
import { Component, inject } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

// EZ
import { EzButtonComponent } from "@template-ui/components/ez-button/ez-button.component";
import { EzDialogComponent } from "@template-ui/components/ez-dialog/ez-dialog.component";


type ViewMoreCellRendererParamType =  ICellRendererParams & {characterLimit?: number, modalWidth?: string, onClick: (params: { event: Event, rowData: Record<string, unknown> }) => void};

@Component({
    selector: "app-view-more-cell-renderer",
    imports: [CommonModule, EzButtonComponent],
    templateUrl: "./view-more-cell-renderer.component.html",
    styleUrls: ["./view-more-cell-renderer.component.scss"]
})
export class ViewMoreCellRenderer implements ICellRendererAngularComp {
  params!: ViewMoreCellRendererParamType;

  text!: string;
  truncText!: string;
  dialog = inject(MatDialog);
  characterLimit = 25;//TODO: make this configurable
  modalWidth = "35%"

  agInit(params: ViewMoreCellRendererParamType): void {
    this.params = params;
    this.text =  this.truncText = this.params.value || null;
    if (this.text !== null && this.text.length > (this.params.characterLimit ?? this.characterLimit) ) {
      this.truncText = this.text.substring(0, this.params.characterLimit ?? this.characterLimit) + "";  //GH experimenting with a "..." button instead of 'view'
    }
    this.modalWidth = this.params.modalWidth ?? "35%";
  }

  refresh(params?: ICellRendererParams): boolean {
    return true;
  }

  onClick($event: Event) {
    //The consumer of this cell renderer can so choose to handle OnClick functionality on their own, or just us to the leg-work
    if (this.params.onClick instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: $event,
        rowData: this.params.node.data
        // ...something
      };
      this.params.onClick(params);
    } else {
      this.dialog.open(EzDialogComponent, {
        width: this.modalWidth,
        data: {
          heading: `View More...`,
          headerStyle: "info",
          consequence: this.text,
          buttons: [
            {
              text: "Close",
              action: (ref: MatDialogRef<EzDialogComponent>) => ref.close()
            }
          ]
        }
      });
    }
  }

  canViewMore() {
    if (this.text !== null) {
      return this.text.length > 25;
    } else {
      return false;
    }
  }
}
